////////LIBRARY/////////
import React, { useEffect, Fragment } from 'react'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import useMedia from 'use-media'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
///////COMPONENTS///////
import Tooltip from '../../../Tooltip/Tooltip'
import { headerCarouselActionCreators } from '../../../../store/actions'
import { useCarousel } from './useCarousel'
/////////ASSETS/////////
import SliderArrowIcon from '../../../../assets/icones/global/back-arrow.svg'

/////////STYLED/////////
const HeaderCarouselHandler = styled.div`
	position: relative;
`
const HeaderCarouselContainer = styled.div`
	display: flex;
	flex-direction: row;
	position: relative;
	justify-content: space-between;
	position: absolute;
	top: 67px;
`
const HeaderCarouselItem = styled.div`
	background-color: ${(props) => props.theme.colors.wedealBlueOther};
	width: 50px;
	height: 50px;
	border-radius: 3px;
	& > a {
		width: 100%;
		height: 100%;
	}
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const LinkCustom = styled(Link)`
	display: flex;
	align-items: center;
	justify-content: center;
`
const HeaderCarouselArrowPrev = styled.div`
	cursor: pointer;
	width: 12px;
	height: 14px;
	background-repeat: no-repeat;
	background-position: center;
	background-image: url(${SliderArrowIcon});
	position: absolute;
	left: -30px;
	top: 50%;
	transform: translateY(-50%);
`
const HeaderCarouselArrowNext = styled.div`
	cursor: pointer;
	width: 12px;
	height: 14px;
	background-repeat: no-repeat;
	background-position: center;
	background-image: url(${SliderArrowIcon});
	position: absolute;
	right: -30px;
	top: 50%;
	transform: translateY(-50%) scale(-1);
`
const HeaderCarouselOverflow = styled.div`
	overflow: hidden;
	position: relative;
	height: 180px;
`
const IconWrapper = styled.img`
	width: 24px;
	height: 24px;
`
/////////STYLED/////////

const HeaderCarousel = (props) => {
	const { userPreferences, headerCarousel, globalLoading } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userPreferences: state.userPreferences,
			headerCarousel: state.headerCarousel,
			globalLoading: state.globalLoading,
		}),
		shallowEqual
	)

	const actionsHeaderCarousel = bindActionCreators(headerCarouselActionCreators, useDispatch())

	const carouselItemList = props.items

	///////////////////////////////// HANDLE ///////////////////////////////////////

	// Check width of window
	const breakdowns = {
		fullWidth: {
			length: carouselItemList.length,
			lengthShowed: 6,
			threshold: 1920,
		},
		mediumWidth: {
			length: carouselItemList.length,
			lengthShowed: 6,
			threshold: 1366,
		},
		minWidth: {
			length: carouselItemList.length,
			lengthShowed: 3,
			threshold: 1280,
		},
	}

	const isMediumWidth = useMedia({ minWidth: breakdowns.minWidth.threshold + 1, maxWidth: breakdowns.fullWidth.threshold - 1 })
	const isMinWidth = useMedia({ maxWidth: breakdowns.mediumWidth.threshold - 1 })

	let setup

	if (isMinWidth) {
		setup = breakdowns.minWidth
	} else if (isMediumWidth) {
		setup = breakdowns.mediumWidth
	} else {
		setup = breakdowns.fullWidth
	}

	// Length of the slides
	const length = setup.length
	// Length of slides to show
	const lengthShowed = setup.lengthShowed

	const [active, setActive, style, styleOverflow] = useCarousel(
		lengthShowed,
		length,
		50,
		headerCarousel.active > -1 ? headerCarousel.active : Math.round((length - lengthShowed) / 2) - 1
	)

	let items = []

	let pos
	for (let i = 1; i <= length; i++) {
		let a = length - lengthShowed

		// number of hidden slides

		if (a === 2 || a <= 0) {
			a = 1
		}

		// Calc of tooltip position, to prevent being cut by overflow
		if (active + a === i) {
			pos = 'right'
		} else if (active + lengthShowed === i || i === length) {
			pos = 'left'
		} else {
			pos = 'bottom'
		}
		!userPreferences.isActived.bool
			? items.splice(0, items.length)
			: items.push(
					<Tooltip key={i} translationsKey={carouselItemList[i - 1]['translationKey']} tooltipId={`tagsListIcon${i}`} position={pos}>
						<HeaderCarouselItem key={i}>
							<LinkCustom to={carouselItemList[i - 1]['link']}>
								<IconWrapper src={carouselItemList[i - 1]['icon']} />
							</LinkCustom>
						</HeaderCarouselItem>
					</Tooltip>
			  )
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		// Retrieve active slide stored
		if (headerCarousel.active > -1) {
			setActive(headerCarousel.active)
		}
	}, [])

	useEffect(() => {
		if (carouselItemList.length > 0) actionsHeaderCarousel.storeActiveValue(active)
	}, [active])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<HeaderCarouselHandler>
			{active > -1 && (
				<Fragment>
					{/* If "active" slide is zero, we cannot prev */}
					{items.length > 0 && active > 0 && !globalLoading.loading && (
						<HeaderCarouselArrowPrev
							onClick={() => {
								setActive(active - 1)
							}}
						/>
					)}
					<HeaderCarouselOverflow style={styleOverflow}>
						<HeaderCarouselContainer style={style}>{items}</HeaderCarouselContainer>
					</HeaderCarouselOverflow>
					{/* If this exceeds the total length, we cannot next */}
					{items.length > 0 && active > -1 && lengthShowed + active < length && !globalLoading.loading && (
						<HeaderCarouselArrowNext
							onClick={() => {
								setActive(active + 1)
							}}
						/>
					)}
				</Fragment>
			)}
		</HeaderCarouselHandler>
	)
}

HeaderCarousel.propTypes = {}

export default HeaderCarousel
